/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiDevice } from './Device';

export interface PostUsersOmniauthRequest {

    provider?: string;

    token?: string;

    code?: string;

    secret?: string;

    expires_at?: number;

    id_token?: string;

    full_name?: string;

    device?: ApiDevice;

    remember_me?: boolean;

    source?: string;

    source_first_time?: boolean;

}

@Model('PostUsersOmniauth')
export class ApiPostUsersOmniauth extends BaseModel implements PostUsersOmniauthRequest {

    
    
    provider: string;

    
    
    token: string;

    
    
    code: string;

    
    
    secret: string;

    
    
    expires_at: number;

    
    
    id_token: string;

    
    
    full_name: string;

    @Type('ApiDevice')
    @Expand()
    device: ApiDevice;

    
    
    remember_me: boolean;

    
    
    source: string;

    
    
    source_first_time: boolean;

}
